import * as React from 'react';
import { Modal } from 'react-bootstrap';

type PickupOrderDialogProps = {
    onCancel: () => void;
    isOpen: boolean;
    title: string;
    textContent: React.ReactNode;
} & { children?: React.ReactNode };

function PickupOrderDialog({
    //onConfirm,
    onCancel,
    children,
    title,
    textContent,
    isOpen
}: PickupOrderDialogProps) {
    return (
        <Modal show={isOpen} onHide={onCancel}>
            <Modal.Header closeButton>
                <h3>{title}</h3>
            </Modal.Header>
            <Modal.Body>{textContent}</Modal.Body>
            <Modal.Footer>{children}</Modal.Footer>
        </Modal>
    );
}

export default PickupOrderDialog;
